import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9 15c3.9 0 7-3.1 7-7V1c0-.6-.4-1-1-1s-1 .4-1 1v7c0 2.8-2.2 5-5 5s-5-2.2-5-5V1c0-.6-.4-1-1-1S2 .4 2 1v7c0 3.9 3.1 7 7 7m8 3H1c-.6 0-1 .4-1 1s.4 1 1 1h16c.6 0 1-.4 1-1s-.4-1-1-1"
    }, null, -1)
  ]))]))
}
export default { render: render }